import axios from 'axios';

const demoApi = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5000',
});

export const getDemoOverview  = (slug) => demoApi.get(`/api/demo/public/${slug}`);
export const getDemoStudents  = (slug) => demoApi.get(`/api/demo/public/${slug}/students`);
export const getDemoClasses   = (slug) => demoApi.get(`/api/demo/public/${slug}/classes`);
export const getDemoPayments  = (slug) => demoApi.get(`/api/demo/public/${slug}/payments`);
export const getDemoExpenses  = (slug) => demoApi.get(`/api/demo/public/${slug}/expenses`);

export const trackDemoView = (slug, source = 'direct') =>
  demoApi.post(`/api/demo/public/${slug}/view`, { source }).catch(() => {});
